import { useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import UILink from 'UIComponents/link/UILink';
import BasePaths from 'automation-ui-routing/BasePaths';
import ActionHistoryCardComponents from 'automation-ui-action-features/actions/ActionHistoryCardComponents';
import { LogEventTypes } from 'automation-ui-log-events/constants/LogEventConstants';
import { getFlowEditActionRouteContextAware } from 'automation-ui-log-events/utils/routing/routingUtils';
import { getContextMap, getType, getFlowId, getAction } from 'automation-ui-log-events/records/LogEvent/utils';
import { useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
// Removes the bold styling applied within action detail components
const RegularWeightSpan = styled.div.withConfig({
  displayName: "LogEventAction__RegularWeightSpan",
  componentId: "sc-1ysmux-0"
})(({
  theme
}) => `
  span {
    font-weight: ${theme.typography['body-100'].fontWeight} !important;
    overflow-wrap: break-word;
  }
  a span {
    font-weight: ${theme.typography['body-125'].fontWeight} !important;
  }
`);
const LogEventAction = ({
  logEvent,
  flowObjectTypeId,
  showActionLink = false,
  revisionId,
  getActionHistoryHeader,
  getActionOutputsForTargetActionById,
  useFullUrl = false
}) => {
  const history = useHistory();
  const {
    search
  } = useLocation();
  const {
    path
  } = useRouteMatch();
  const isOnEditor = path.indexOf(`/${BasePaths.PLATFORM}/${BasePaths.FLOW}/:flowId/:screen?`) !== -1;
  const type = getType(logEvent);
  const flowId = getFlowId(logEvent);
  const action = getAction(logEvent);
  const contextMap = getContextMap(logEvent);
  if (type === LogEventTypes.ENROLLMENT || type === LogEventTypes.UNENROLLMENT || type === LogEventTypes.PRE_ENROLLMENT) {
    return /*#__PURE__*/_jsx("span", {
      children: `--`
    });
  }
  if (!action) {
    if (type === LogEventTypes.ACTION_EXECUTION) {
      return /*#__PURE__*/_jsx("span", {
        children: `--`
      });
    }
    return null;
  }
  const actionType = action.getActionType();
  const ActionHistoryCardComponent = ActionHistoryCardComponents[actionType];
  if (!ActionHistoryCardComponent) {
    return null;
  }
  const actionRoute = getFlowEditActionRouteContextAware(flowId, action, revisionId, useFullUrl);
  const actionLink = showActionLink ? useFullUrl ? actionRoute : history.createHref({
    pathname: actionRoute,
    search
  }) : null;
  const actionLabel = isOnEditor && showActionLink && revisionId === undefined ? /*#__PURE__*/_jsx(UILink, {
    onClick: () => history.push({
      pathname: actionRoute,
      search
    }),
    children: getActionHistoryHeader({
      action
    })
  }) : getActionHistoryHeader({
    action,
    actionLink: actionLink
  });
  return /*#__PURE__*/_jsx(RegularWeightSpan, {
    children: /*#__PURE__*/_jsx(ActionHistoryCardComponent, {
      action: action,
      actionId: action.getActionId(),
      actionLabel: actionLabel,
      actionMetadata: action.getMetadata(),
      contextMap: contextMap,
      flowObjectTypeId: flowObjectTypeId,
      getActionLabelById: getActionHistoryHeader,
      getActionOutputsForTargetActionById: getActionOutputsForTargetActionById
    })
  });
};
export default LogEventAction;